module.exports = __webpack_public_path__ + "static/media/tapan_logo_circled.7e17e79e.png";